var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nuxt-link',{attrs:{"to":_vm.link}},[_c('v-img',{staticClass:"logo",attrs:{"src":_vm.imageUrl,"alt":_vm.$theme.current,"contain":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }